<template>
  <div>
    <common :dataSource='dataSource' :type="5"></common>
  </div>
</template>
<script>
import common from './common.vue'
export default {
  components: {
    common
  },
  data() {
    return {
      dataSource: [
        [
          {
            type: 3,
            title: '对于刚完成的任务，请按照你的真实感受做出判断，并点击选项前的“ <span class="circle"></span> ”选择'
          },
          {
            type: 2,
            headline: '1.你对“中国空间站的科学实验”任务感兴趣吗？',
            value: [
              '很不感兴趣', '不感兴趣', '一般', '感兴趣', '非常感兴趣'
            ]
          },
          {
            type: 2,
            headline: '2.你对“中国空间站的科学实验”任务的场景熟悉吗？',
            value: [
              '很不熟悉', '不熟悉', '一般', '熟悉', '很熟悉'
            ]
          },
          {
            type: 2,
            headline: '3.你对“禽流感的防控”任务感兴趣吗？',
            value: [
              '很不感兴趣', '不感兴趣', '一般', '感兴趣', '非常感兴趣'
            ]
          },
          {
            type: 2,
            headline: '4.你对“禽流感的防控”任务的场景熟悉吗？',
            value: [
              '很不熟悉', '不熟悉', '一般', '熟悉', '很熟悉'
            ]
          },
          {
            type: 2,
            headline: '5.你对“未来的遥控器”任务感兴趣吗？',
            value: [
              '很不感兴趣', '不感兴趣', '一般', '感兴趣', '非常感兴趣'
            ]
          },
          {
            type: 2,
            headline: '6.你对“未来的遥控器”任务的场景熟悉吗？',
            value: [
              '很不熟悉', '不熟悉', '一般', '熟悉', '很熟悉'
            ]
          },
        ]
      ]
    }
  }
}
</script>
<style lang="less">
.circle{
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  border: 1px solid #3c3c3c;
}
</style>
